import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import focusable from '../../components/Focusable/Focusable'
import FocusableDiv from '../../components/FocusableDiv/FocusableDiv'
import StationPassportTitle from '../../components/StationPassportTitle/StationPassportTitle'
import tts from '../../lib/TTS'
import * as UI from '../../lib/ui'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

class PassPortUpsell extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      shortCommonName: null,
    }
    this.passportUpsellRef = React.createRef()

    this.station = this.props.station
    if (this.props.router.location.search.indexOf('membership=true') !== -1) {
      this.station =
        this.props.memberships.find(
          (membership) =>
            membership.call_sign === this.props?.router.params?.callsign
        ) || this.station
    }
  }

  componentDidMount() {
    UI.setSidePanelVisibility(false)

    this.learnMoreUrl = ''
    this.callsignToMatch = this.station.call_sign
    this.isVideoUpsell =
      this.props.router.location.search &&
      -1 !== this.props.router.location.search.indexOf('?video=')
    this.goBackUrl = this.props.router.location.state?.goBackParameterUrl

    if (this.callsignToMatch === this.station.call_sign) {
      this.learnMoreUrl = this.station.passport_learn_more_url
        ? this.props.station.passport_learn_more_url
        : 'https://pbs.org/passport/learn-more'
      this.setState({ shortCommonName: this.station.short_common_name })
    } else {
      for (const i in this.props.memberships) {
        let membership = this.props.memberships[i]

        if (this.callsignToMatch === membership.call_sign) {
          this.learnMoreUrl = membership.passport_learn_more_url
            ? membership.passport_learn_more_url
            : membership.website_url
            ? membership.website_url
            : 'https://pbs.org/passport/learn-more'
          this.setState({ shortCommonName: membership.short_common_name })
        }
      }
    }

    googleAnalytics4.sendPageViewEvent(
      `Passport Handoff - ${this.isVideoUpsell ? 'Video' : 'Other'}`
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.shortCommonName !== prevState.shortCommonName) {
      const { shortCommonName } = this.state
      this.passportUpsellRef.current?.setFocus()

      let videoUpsellCopy = this.isVideoUpsell
        ? `Watch this video with  ${shortCommonName} Passport...`
        : ''

      tts.addTextToRead(
        `${shortCommonName} Passport... ${videoUpsellCopy} ${shortCommonName} Passport is an additional member benefit that provides extended access to quality PBS streaming video. To learn more and sign up now, visit: ${this.learnMoreUrl}. Press the back button to return to Settings.`
      )
    }
  }

  componentWillUnmount() {
    tts.stopRead()
  }

  onKeyEvent(key) {
    let handled = false
    if ('BACK' === key) {
      tts.stopRead()

      if (this.goBackUrl) {
        this.props.router.navigate(`/video-details/${this.goBackUrl}`, {
          replace: true,
        })
      } else {
        this.props.router.navigate(-1)
      }
      handled = true
    }

    return handled
  }

  render() {
    const { shortCommonName } = this.state

    return (
      <FocusableDiv
        className="focusableDivUpsell"
        parent={this}
        id={'focusableDivUpsell'}
        componentType="focusableDivUpsell"
        ref={this.passportUpsellRef}
      >
        <div className="passport-upsell-container">
          <div className="upsell">
            <StationPassportTitle
              className="header"
              stationTitle={shortCommonName}
            />

            {this.isVideoUpsell && (
              <p className={`description ${this.isVideoUpsell ? 'video' : ''}`}>
                Watch this video with {shortCommonName} Passport.
              </p>
            )}
            <p className="description">
              {shortCommonName} Passport is an additional member benefit that
              provides extended access to quality PBS streaming video.
            </p>
            <p className="link-text">
              To learn more and sign up now, visit:{' '}
              <span className="url-font">
                {this.learnMoreUrl
                  ? this.learnMoreUrl.replace('http://', '')
                  : ''}
              </span>
            </p>
          </div>
        </div>
      </FocusableDiv>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    station: state.station,
    memberships: state.user.memberships,
  }
}

PassPortUpsell.propTypes = {
  station: PropTypes.shape({
    call_sign: PropTypes.string,
    short_common_name: PropTypes.string,
    passport_learn_more_url: PropTypes.string,
  }),
  router: PropTypes.shape({
    navigate: PropTypes.func,
    params: PropTypes.shape({
      callsign: PropTypes.string,
    }),
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.shape({
        goBackParameterUrl: PropTypes.string,
      }),
    }),
  }),
  user: PropTypes.shape({
    memberships: PropTypes.array,
  }),
  memberships: PropTypes.array,
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(PassPortUpsell)))
